module.exports = {
  footerText: 'Copyright Freedom logistics © 2022',
}
